import { SET_PAGE } from './actions'
import { PageState } from './types'

const setPage = (
	state: PageState,
	{ title = '', description = '', actions = [], canGoBack = false, goBackParams = [] }: any
) => {
	return {
		...state,
		title,
		description,
		actions,
		canGoBack,
		goBackParams
	}
}

export const reducer = (state: any, { type, payload }: any) => {
	switch (type) {
		case SET_PAGE:
			return setPage(state, payload)
		default:
			return state
	}
}
